import { exists } from '@shared/numbers';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-backtest-number-display',
  templateUrl: './backtest-number-display.component.html',
  styleUrls: ['./backtest-number-display.component.scss']
})
export class BacktestNumberDisplayComponent {
  @Input() value: number;
  @Input() type: 'currency' | 'financial' | 'percentage' | 'integer' | 'decimal';
  @Input() reverse = false;
  @Input() negative = false;
  @Input() positive = false;
  @Input() color = 'default';

  get showNegative() {
    if (this.negative) {
      return !this.reverse;
    }
    return this.reverse ? this.value > 0 : this.value < 0;
  }

  get classColor() {
    if (this.color !== 'default') {
      return this.color;
    }

    if (this.negative || (this.reverse && this.positive)) {
      return 'negative';
    }
    if (this.positive || (this.reverse && this.negative)) {
      return 'positive';
    }

    if (Math.round(this.value * 100) === 0) {
      return '';
    }

    if (this.reverse) {
      return this.value < 0 ? 'positive' : 'negative';
    } else {
      return this.value > 0 ? 'positive' : 'negative';
    }
  }

  get hasValue() {
    return exists(this.value);
  }

  constructor() {}
}
